export const LABEL_STYLE = 'text-secondary-50 flex-shrink-0';
export const LABEL_STYLE_COLLAPSE = 'lg:group-[.collapsed]:hidden';
export const BUTTON_STYLE =
  'hover:bg-primary-300 flex items-center flex-shrin rounded-[20px] px-[16px] py-[8px]  w-full hover:bg-opacity-20 text-secondary-50 gap-2';
export const BUTTON_STYLE_COLLAPSE =
  'lg:group-[.collapsed]:rounded-full lg:group-[.collapsed]:w-fit lg:group-[.collapsed]:p-3';
